import moment from 'moment';
import { Moment } from 'moment';
import { FORMAT } from '@core/utils/formats';
import { MOMENT_UNIT } from '@core/utils/moment';
import { getLocalMomentFromUtc } from '@core/utils/date-time';

export class BillingEstimate {
    public items: any[];
    public owner_id: string;
    public period_end: string;
    public period_start: string;
    public starting_balance: number;
    public total: number;

    get nextCycle(): string {
        const periodEndMoment: Moment = moment(
            this.period_end,
            FORMAT.DATE_SHORT
        ).add(1, MOMENT_UNIT.DAYS);
        return periodEndMoment.format('D MMM');
    }

    get daysLeft(): number {
        const todayMoment: Moment = moment().startOf('day');
        const periodEndMoment: Moment = getLocalMomentFromUtc(this.period_end);
        const daysLeft: number = periodEndMoment.diff(
            todayMoment,
            MOMENT_UNIT.DAYS
        );
        return daysLeft >= 0 ? daysLeft : 0;
    }

    get duration(): number {
        const periodStartMoment: Moment = moment(
            this.period_start,
            FORMAT.DATETIME_LONG
        );
        const periodEndMoment: Moment = moment(
            this.period_end,
            FORMAT.DATETIME_LONG
        );
        return periodEndMoment.diff(periodStartMoment, MOMENT_UNIT.DAYS);
    }

    get percentDaysUsed(): number {
        return ((this.duration - this.daysLeft) / this.duration) * 100;
    }

    get periodStartFormatted(): string {
        return getLocalMomentFromUtc(this.period_start).format('ddd, MMM DD');
    }

    get periodEndFormatted(): string {
        return getLocalMomentFromUtc(this.period_end).format('ddd, MMM DD');
    }
}
